export const getTwoLinesLabels = (words, limit) => {
  const aux = []
  let concat = []

  for (let i = 0; i < words.length; i++) {
    concat.push(words[i])
    const join = concat.join(" ")
    if (join.length > limit) {
      aux.push(join)
      concat = []
    }
  }

  if (concat.length) {
    aux.push(concat.join(" ").trim())
  }
  const firstLine = aux.slice(0, Math.round(aux.length / 2)).join(" ")
  const secondLine = aux.slice(Math.round(aux.length / 2)).join(" ")

  return [firstLine, secondLine]
}